import moment from "moment";
import { any, func } from "prop-types";
import React from "react";
import { connect } from "react-redux";
import FormCreator from "../../common/FormCreator";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import HorizontalLine from "../../common/HorizontalLine";
import history from "../../history";
import { postRoyalMailForm } from "../../redux/actions/royalMailActions";
import * as style from "./styles.module.scss";

const DeclarationForm = ({ appData, postRoyalMailFormFunc }) => {
  const { firstName: initFirstName = "", lastName: initLastName = "" } =
    appData;
  const initialState = {
    declaration: {
      htmlObj: (
        <div>
          <HorizontalLine
            text={"Royal Mail Groups obligations"}
            desc={
              "Royal Mail Group must ensure that letters, parcels and all other communications or items entrusted to it are delivered as addressed promptly and safely, and that the information in them reaches no one not entitled to it. To help Royal Mail Group provide this essential service to the community, there are important legal requirements which you must comply with. It is important for you to be aware of and understand those provisions, not only for your own sake but also in order that you should not, through any fault or omission on your part, enable or tempt others to break them."
            }
          />
          <HorizontalLine
            text={"Safety of Postal Packets"}
            desc={`
          It is a criminal offence to steal, deliberately destroy or damage a
          letter, parcel, mailbag or any other postal packet in course of
          transmission by post. It is also an offence to open or delay (contrary
          to your duty) a letter, parcel, mailbag, or any other postal packet in
          course of transmission by post. Persons suspected of criminal offences
          will be subject to investigation which may lead to prosecution in the
          criminal courts. Serious penalties, including terms of imprisonment,
          are provided for such offences. Other misconduct which endangers the
          safety of a mailbag or postal packet may lead to termination of
          employment or engagement or contract with Royal Mail Group.`}
          />
          <HorizontalLine
            text={"Preventing and Reporting Crime"}
            desc={`
          You have a civil and contractual duty to report any suspicions that
          you have of criminal behaviour in others and Royal Mail is committed
          to recover the value of any loss caused by crime and the
          investigation/prosecution costs.`}
          />
          <HorizontalLine
            text={"Criminal Offences"}
            desc={`
          If you are charged with any criminal offence whilst employed or
          engaged by Royal Mail Group, you must immediately inform your
          supervisor of the details. Where a person engaged in Royal Mail
          business is involved in a criminal offence, the police have discretion
          to notify Royal Mail of convictions and may provide other relevant
          information.`}
          />
          <HorizontalLine
            text={"Confidential Information"}
            desc={`
          You must not whilst employed or contractually bound by Royal Mail
          Group or engaged in Royal Mail Group’s business, nor after that
          employment or engagement ceases, disclose to any other person, firm or
          company, or publish or broadcast or use for your own benefit or for
          the benefit of a third party any confidential information relating in
          any way to the activities, operations or business methods of Royal
          Mail Group or its business partners, except as previously authorised
          in writing by or on behalf of Royal Mail Group. Any unauthorised
          disclosure may amount to a criminal offence.`}
          />
          <HorizontalLine
            text={
              "Our Business Standards(or any standards that may replace this)"
            }
          />
          <HorizontalLine
            desc={`High standards of personal behaviour at work are expected of everybody
          who works for the company, as set out in the Royal Mail Group’s Code
          of Business Standards. You are expected to:`}
          />
          <p className={style.declarationform__subtext}>
            <ul>
              <li>
                Conduct yourself appropriately in line with Our Business
                Standards
              </li>
              <li>Operate within the law</li>
              <li>
                Adopt the guiding principles of Equality and Fairness Policy
              </li>
              <li>
                All RMG employees and agency workers must inform your manager of
                any second job you have or intend to with another employer
                however this job must not be working for a competitor of Royal
                Mail Group. (This clause does not apply to Owner Drivers,
                Couriers or any designated drivers).
              </li>
            </ul>
            In addition, you should demonstrate: efficiency and reliability,
            punctuality and good attendance, honesty and integrity and a smart
            and clean appearance.
          </p>
          <p className={style.declarationform__subtext}>
            Conduct which damages service to customers or the reputation or
            efficiency of the company is unacceptable, including for example,
            lateness, poor attendance, dishonesty, drunkenness, use of illegal
            substances or violent behaviour. Please remember that gambling is
            not permitted on duty or company premises, and that staff clubs can
            only exist if they comply with the company rules.
          </p>
          <HorizontalLine
            text={"Photo ID"}
            desc={`
          In signing this document you agree that you understand that
          it is an absolute requirement for you to display or to be able to
          produce Royal Mail photographic identification, or in the case of
          contractors other agreed photographic identification, at all times
          that you are on duty or within Royal Mail premises.`}
          />
          <HorizontalLine
            text={"Data Protection"}
            desc={`
          Any person who handles information about identifiable
          living people whether processed electronically or manually may also
          commit an offence under the prevailing data protection legislation if
          he/she knowingly or recklessly handles personal data without the
          consent of the data controller; procures or discloses the personal
          data of another person without the consent of the data controller; or
          retains personal data, after it has been obtained, without the consent
          of the person who was the controller when the data was
          obtained.`}
          />
          <p>
            I have read and fully understand this document. I understand that it
            forms part of my contractual duty to adhere to all of the standards
            defined above. I agree that a copy will be retained in my file.{" "}
          </p>
          <p>
            If you are an agency worker or contractor, you agree that signing
            this form does not imply that you should be construed as an employee
            of Royal Mail Group and you accept and agree that you are not an
            employee of Royal Mail Group.
          </p>
          <p>
            If completed online, please type/print your name below. The return
            of this document replaces the requirement for your handwritten
            signature.
          </p>
        </div>
      ),
    },
    fullName: {
      title: "Full name:",
      mandatory: true,
      value: `${initFirstName} ${initLastName}`,
    },
    signature: {
      title: "Signature:",
      value: `${initFirstName} ${initLastName}`,
    },
    date: {
      title: "Date:",
      value: `${moment().format("DD/MM/YYYY")}`,
    },
  };
  const [fields, setField] = useForm(initialState);
  const handleSubmit = () => {
    postRoyalMailFormFunc(
      "declarationForm",
      formCreatorConvertToValues(fields)
    );
    history.push("/profile/edit/royal-mail-onboarding");
  };
  return (
    <FormCreator
      formTitle={"Personal Declaration to Royal Mail Group"}
      description={
        "You should read this document carefully and then sign your name to the declaration below."
      }
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
    />
  );
};

DeclarationForm.propTypes = {
  appData: any,
  postRoyalMailFormFunc: func,
};
const mapDispatchToProps = {
  postRoyalMailFormFunc: postRoyalMailForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(DeclarationForm);
